import { css } from "@emotion/css"

export const styles = {
  container: css`
    display: grid;
    grid-auto-columns: max-content;
    grid-auto-flow: column;
    padding: var(--spacing-xxs) 0 0;
    align-items: center;
  `,
  labelPlacementStart: css`
    margin: 0;
  `,
  label: css`
    min-width: 70px;
  `,
}
